export default __webpack_public_path__ + "static/media/thumb-IVTS-2.44be9fbf.png";